import React from "react";
import { Link } from "react-router-dom";
import { LocationState } from "history";

import { Routes } from "constants/routes";
import { useNavigate } from "hooks";
import { ExtractRouteParams, RoutePath, RoutesKeys } from "store/types";
import { Typography } from "@mui/material";

interface IProps<R extends RoutesKeys> {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  route?: R;
  params?: ExtractRouteParams<RoutePath<R>>;
  allowNewTab: boolean;
  beforeNavigate?: () => void;
  disableLink?: boolean;
  state?: LocationState;
}
export const NavigateLink = <R extends RoutesKeys>({
  children,
  style,
  className,
  params,
  route,
  allowNewTab,
  disableLink,
  beforeNavigate,
  state = {}
}: IProps<R>) => {
  const navigate = useNavigate();

  const linkBuilder = () => {
    if (!route) return "#";
    const currentRoute = Routes[route];
    if (!currentRoute) {
      return "#";
    }

    let link: string = currentRoute;
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const regex = new RegExp(":" + key, "g");
        link = link.replace(regex, String(params[key]));
      }
    }

    return link;
  };

  if (allowNewTab && !disableLink) {
    return (
      <Link
        className={className}
        style={{
          color: "#173c4c",
          textDecoration: "none",
          cursor: "pointer",
          ...style
        }}
        onClick={() => {
          if (beforeNavigate) beforeNavigate();
        }}
        to={{ pathname: linkBuilder() || "#", state }}
      >
        {children}
      </Link>
    );
  }

  return (
    <Typography
      noWrap
      style={{
        cursor: disableLink ? "default" : "pointer",
        ...style
      }}
      onClick={() => {
        if (disableLink) return;
        if (beforeNavigate) beforeNavigate();
        navigate({ route: route as RoutesKeys, params: params, state });
      }}
    >
      {children}
    </Typography>
  );
};
